import { Field, FieldProps } from 'formik';

import useRendererFunctions from '../../../hooks/useRendererFunctions';
import { FormCustomField, FormElementProps } from '../../../types';

interface CustomTypeRendererProps<TValue extends any = any> extends FieldProps<TValue> {
  name: string;
  Component: FormCustomField<TValue>['Component'];
}

const CustomInputRenderer = <TValue extends any = any>(props: CustomTypeRendererProps<TValue>) => {
  const {
    name,
    Component,
    field: { value },
    form: { setFieldValue, setFieldError, setFieldTouched, setStatus, status },
    meta: { error, touched },
  } = props;

  const { onChange, setErrorElement, setNudgeState } = useRendererFunctions<TValue>({
    name,
    setFieldValue,
    setStatus,
    status,
  });

  return Component({
    name,
    value,
    error,
    touched,
    onChange,
    setFieldError,
    setFieldTouched,
    setFieldValue,
    setErrorElement,
    setNudgeState,
  });
};

// use generics
const CustomInputField = (props: FormElementProps<FormCustomField>) => {
  const { field } = props;

  return (
    <Field name={field.name}>
      {(fastField: FieldProps) => (
        <CustomInputRenderer Component={field.Component} name={field.name} {...fastField} />
      )}
    </Field>
  );
};

export default CustomInputField;
